<div class="mzic-popover active modal-popover" [ngClass]="additionalClasses">
  <ng-content></ng-content>
  <ng-template #container></ng-template>
</div>
